import React from 'react'
import one from '../Images/hairtrim-modified.png';
import second from '../Images/massage-modified.png';
import third from '../Images/hammamaghreb-modified.png';
import fourth from '../Images/hands-modified.png';
import fifth from '../Images/lasertreat-modified.png';
import sixth from '../Images/trim-modified.png';   


export default function PriceText() {
    return (
        <div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={second} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">تدليك استرخائي</h2>
                            <p className="card-text">فقط بـ 150 ريال</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={third} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">حمام مغربي</h2>
                            <p className="card-text">فقط بـ 150 ريال</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={fourth} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">بديكير رجول ويدين</h2>
                            <p className="card-text">فقط بـ 170 ريال</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={fifth} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">تنظيف البشرة بالليزر</h2>
                            <p className="card-text">فقط بـ 150 ريال</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={one} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">قصة شعر أنيقة</h2>
                            <p className="card-text">فقط بـ 25 ريال</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters">
                    <div className="col">
                        <img src={sixth} alt="pic" className="card-img" />
                    </div>
                    <div className="col">
                        <div className="card-body">
                            <h2 className="card-title">حلاقة دقن</h2>
                            <p className="card-text">فقط بـ 25 ريال</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

